<template>
  <div class="smiley-rating">
    <template v-for="(rating, index) in feedbackRatingOptions">
      <div
        :class="['per-rate', { decision: isRatingGroup2 }]"
        v-if="rating.option_group === ratingOptionGroup"
        :key="index"
        v-bind:vote="vote"
        v-on:click="setRating(rating.vote_value)"
      >
        <img
          :src="getRatingEmoji(rating.vote_value, vote === rating.vote_value)"
          :class="['emoji']"
        />
        <span class="text">{{ formattedMessage(rating.option_ja) }}</span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { CUSTOMER_RATING } from '@/utils/constants';

export default {
  model: {
    prop: 'vote',
    event: 'click'
  },
  props: {
    vote: Number,
    ratingOptionGroup: Number
  },
  data() {
    return {
      ratingSmileyImage: [
        {
          voteValue: CUSTOMER_RATING.veryBad,
          image: require('@/assets/img/icon/vote_verybad.svg'),
          imageActive: require('@/assets/img/icon/vote_verybad_active.svg')
        },
        {
          voteValue: CUSTOMER_RATING.bad,
          image: require('@/assets/img/icon/vote_bad.svg'),
          imageActive: require('@/assets/img/icon/vote_bad_active.svg')
        },
        {
          voteValue: CUSTOMER_RATING.neutral,
          image: require('@/assets/img/icon/vote_neutral.svg'),
          imageActive: require('@/assets/img/icon/vote_neutral_active.svg')
        },
        {
          voteValue: CUSTOMER_RATING.good,
          image: require('@/assets/img/icon/vote_good.svg'),
          imageActive: require('@/assets/img/icon/vote_good_active.svg')
        },
        {
          voteValue: CUSTOMER_RATING.veryGood,
          image: require('@/assets/img/icon/vote_verygood.svg'),
          imageActive: require('@/assets/img/icon/vote_verygood_active.svg')
        }
      ]
    };
  },
  computed: {
    ...mapState('customerFeedback', ['feedbackQuestions', 'feedbackRatingOptions']),

    isRatingGroup2() {
      return this.ratingOptionGroup === 2;
    }
  },
  methods: {
    getRatingEmoji(value, active) {
      const emoji = this.ratingSmileyImage.find((key) => key.voteValue === value);
      return active ? emoji?.imageActive : emoji?.image;
    },
    setRating(value) {
      this.$emit('click', value);
    },
    formattedMessage(option) {
      return option.replace(/\\n/g, '\n');
    }
  }
};
</script>

<style lang="scss" scoped>
.smiley-rating {
  display: flex;
  justify-content: space-between;
  flex: 1;

  .per-rate {
    display: flex;
    align-items: center;
    cursor: pointer;
    @media screen and (max-width: 760px) {
      flex-direction: column;
      align-items: center;
      justify-items: center;
      width: 68px;
      box-sizing: border-box;
      .text {
        font-weight: 500;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        margin-top: 4px;
        margin-left: 0px;
        text-align: center;
        display: flex;
        flex: 1;
        white-space: pre-line;
        line-height: 18px;
      }
    }
  }

  .emoji {
    width: 24px;
  }

  .text {
    margin-left: 8px;
    font-weight: 500;
  }
}
</style>
